import React from 'react';

const Howdoesitwork = () => {
  const steps = [
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1579389083078-4e7018379f7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      category: "ÉTAPE 1",
      title: "Diagnostic initial",
      description: "Évaluation de vos objectifs et compétences",
      date: "Première semaine",
      link: "#"
    },
    {
      id: 2,
      image: "https://images.unsplash.com/photo-1543286386-713bdd548da4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      category: "ÉTAPE 2",
      title: "Plan personnalisé",
      description: "Feuille de route claire vers la certification ou le projet",
      date: "Deuxième semaine",
      link: "#"
    },
    {
      id: 3,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      category: "ÉTAPE 3",
      title: "Sessions avec votre tuteur",
      description: "Rendez-vous 1:1 hebdomadaires + feedback continu",
      date: "Chaque semaine",
      link: "#"
    },
    {
      id: 4,
      image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      category: "ÉTAPE 4",
      title: "Validation & Certification",
      description: "Simulation d'examens, préparation aux livrables FabAcademy ou projets finalisés",
      date: "Phase finale",
      link: "#"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header avec titre et bouton */}
        <div className="flex flex-col lg:flex-row justify-between items-center gap-5 mb-12 lg:mb-16">
          <div className="lg:w-1/2 text-center lg:text-left">
            <h2 className="text-title font-bold text-dark-1 mb-3">Comment ça marche ?</h2>
            <p className="text-subtitle text-gray-600">
              Un accompagnement en 4 étapes pour atteindre vos objectifs
            </p>
          </div>
          
          <div className="mt-6 lg:mt-0">
            <a 
              href="/become-an-instructor" 
              className="inline-flex items-center px-5 py-3 rounded-full bg-white text-red-4 border-2 border-red-4
              hover:bg-red-4 hover:text-white transition-colors duration-300 text-button"
            >
              En savoir plus
              <svg 
                className="w-4 h-4 ml-2" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>
        </div>

        {/* Grille des articles de blog */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((post, index) => (
            <BlogCard 
              key={post.id} 
              post={post} 
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

// Composant BlogCard séparé
const BlogCard = ({ post }) => {
  return (
    <div className="bg-white overflow-hidden flex flex-col h-full group">
      <a href={post.link} className="flex-grow flex flex-col">
        <div className="overflow-hidden h-48 relative">
          <div className="absolute top-4 left-4 z-10 bg-purple-1 text-white text-xs font-bold px-3 py-1 rounded-full">
            {post.category}
          </div>
          <img 
            src={post.image} 
            alt={post.title} 
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="py-5 flex-grow flex flex-col">
          <h3 className="text-subtitle font-bold text-dark-1 mb-2 leading-tight">
            {post.title}
          </h3>
          <p className="text-gray-600 text-normal mb-4 flex-grow">
            {post.description}
          </p>
        </div>
      </a>
    </div>
  );
};

export default Howdoesitwork;